import URI from "urijs";
import { useLocation } from "react-router-dom";
import { GlobalStore } from "../stores/global";

export default () => {
  const { currentCountryCode: countryCode } = GlobalStore.useState(s => s);

  const location = useLocation();
  if (countryCode) {
    let rgx = new RegExp("^/" + countryCode.toLowerCase() + "/([^/]+/[^/]+)/{0,1}$", "i");
    if (rgx.test(location.pathname)) {
      return location.pathname.replace(rgx, "$1");
    }
  }
  const slug = new URI(location.pathname).segment(1);

  return slug;
};
